<template>
    <div class="ActionableAlert">
        <Alert :type="type">
            <div class="ActionableAlert__titleSection">
                <FontAwesomeIcon v-if="icon" :icon="icon" />
                <span class="ActionableAlert__title">{{ title }}</span>
            </div>
            <NewButton
                v-if="actionTitle"
                type="primary"
                class="ActionableAlert__actionButton"
                @click="$emit('action', name)"
            >
                {{ actionTitle }}
            </NewButton>
        </Alert>
    </div>
</template>

<script lang="ts">
    import { Component, Prop } from '@evidentid/vue-property-decorator';

    import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import Alert from '@evidentid/dashboard-commons/components/Alert/Alert.vue';
    import AlertBase from '@evidentid/dashboard-commons/components/Alert/AlertBase';

    import NewButton from '@/components/new-button/NewButton.vue';

    // PRODUCT-26110 Phase 2B2 Task 4: extends AlertBase (a plain .ts class), not
    // Alert.vue's own default export -- vue-loader 17 wraps every SFC's default export
    // via exportHelper() (stamping __vccOpts onto a new object, not the class itself),
    // so `extends <SFC default export>` no longer extends a real class at runtime. The
    // <Alert> child component below is unaffected -- rendering a component as a child
    // in a template was never broken, only extending its class was.
    @Component({
        emits: [ 'action' ],
        components: { Alert, NewButton, FontAwesomeIcon },
    })
    export default class ActionableAlert extends AlertBase {
        @Prop({ type: String, default: null })
        private name!: string | null;

        @Prop({ type: Object, default: null })
        private icon!: IconDefinition | null;

        @Prop({ type: String, default: null })
        private actionTitle!: string | null;
    }
</script>
